<template>
  <div class="product-browser-filters">
    Filter:
    <span v-show="filtersApplied.length < 1" class="product-browser-filter">All Products</span>
    <span v-for="filter in filtersApplied" class="product-browser-filter">
      <span class="filter-name">{{ formatText(filter.type) }}</span>:
      <span class="filter-value">{{ getFilterDisplay(filter.type, filter.id) }}</span>
      <span @click="$emit('unapply-filter', filter)" class="filter-clear"></span>
    </span>
    <button
      type="button"
      class="product-browser-filter-button"
      @click.prevent="addFilter"
      >
      Add Filter
    </button>
    <button
      v-show="filtersApplied.length > 0"
      type="button"
      class="product-browser-filter-button"
      @click.prevent="$emit('clear-filters')"
      >
      Clear Filters
    </button>

    <div class="modal modal-filter" :class="{ 'is-active': modalFilterOpen }">
      <div class="modal-card">
        <header>
          <div><a href="#close-modal" aria-label="close" @click.prevent="closeFilterModal">X close</a></div>
        </header>
        <section v-if="filterOptions" class="modal-card-body">
          <div class="form-group">
            <label for="filterType">Filter By</label>
            <select v-model="filterTypeSelected">
              <option v-for="(item, index) in filterOptions" v-bind:value="index">{{ formatText(index) }}</option>
            </select>
          </div>
          <div v-for="(optionsArray, index) in filterOptions" class="form-group radio-buttons" v-if="filterTypeSelected == index">
            <label v-for="(optionName, optionId) in optionsArray">
              <input type="radio" :value="optionId" :key="optionId" v-model="filterValueSelected" @click="addFilterValue(optionId)" />
              {{ optionName }}
            </label>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterDisplay',
  props: {
    articles: Object,
    modalFilterOpen: false,
    filterOptions: Object,
    filtersApplied: Array,
    filterTypeSelected: null,
    filterValueSelected: null,
  },
  methods: {
    addFilter() {
      this.modalFilterOpen = true
    },
    addFilterValue(optionSelected) {
      this.filterValueSelected = optionSelected
      this.$emit('filter-on', this.filterTypeSelected, this.filterValueSelected)
      this.closeFilterModal()
    },
    closeFilterModal() {
      this.modalFilterOpen = false
      this.filterTypeSelected = null
      this.filterValueSelected = null
    },
    formatText(string) {
      return string.replace(/_/g, ' ')
    },
    getFilterDisplay(filterName, valueId) {
      switch (filterName) {
        case 'article':
          return this.articles[`id${valueId}`].name
        default:
          return this.filterOptions[filterName][valueId]
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/FilterDisplay.vue